<template>
  <div class="modalOverlay" @click="closeOnOverlayClick">
    <div class="graficoContainer">
      <div class="modal-content-InicioModal" @click.stop>
        <div style="height: 100%; width: 100%">
          <div class="modal-top">
            <!-- EL TOP -->
            <div class="innerModalTop">
              <!-- ACÁ ESTÁ EL LADO IZQUIERDO DEL TOP -->
              <div style="display: flex; flex-direction: column">
                <div class="imagenYtitulo" id="content">
                  <img
                    src="@/assets/images/tramite-muni.svg"
                    style="width: 22.378px; height: 22.378px"
                  />
                  <p class="titulos">Multas</p>
                </div>
                <b
                  class="titulos"
                  style="
                    font-size: 20.134px;
                    line-height: 28.762px;
                    margin-top: -20px;
                    word-wrap: break-word; /* Fuerza el salto cuando el texto es muy largo */
                  "
                  >{{ infraction.infraType.name }}</b
                >
                <div>
                  <p class="titulos" style="margin: 0px">
                    {{
                      infraction.infraType.type +
                      infraction.act.act_number.toString().padStart(6, "0")
                    }}
                  </p>
                  <p class="titulos" style="margin: 0px">
                    {{ infraction.inspector_name }}
                    {{ infraction.inspector_lastname }}
                  </p>
                </div>
              </div>
              <!-- ACÁ ESTÁ EL LADO DERECHO DEL TOP -->
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: flex-end;
                "
              >
                <b>{{ formatDate(infraction.createdAt) }}</b>
                <div v-if="originalInfra.internal_number">
                  N°
                  {{ infraction.internal_number.toString().padStart(6, "0") }}
                  <img
                    src="/img/iconGreen-download.svg"
                    alt=""
                    @click="tryDownload"
                    style="cursor: pointer; width: 24.301px; height: 24.301px"
                  />
                </div>
                <div
                  v-else
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;
                  "
                >
                  <b class="user-text">Numero de seguimiento interno:</b>
                  <p class="user-info">
                    <button
                      v-if="
                        isValidInternalNumber &&
                        isInternalNumberAvailable &&
                        !searchingInt
                      "
                      class="butonTilde"
                      style="margin-right: 5px"
                      @click="saveInternalNumber()"
                    >
                      <p style="color: var(--bg-popup)">✓</p>
                    </button>
                    <input
                      type="number"
                      v-model="infraction.internal_number"
                      :class="{
                        invalid:
                          !isValidInternalNumber || !isInternalNumberAvailable,
                      }"
                    />
                  </p>
                  <span v-if="!isInternalNumberAvailable" class="error-text"
                    >Ya en uso</span
                  >
                </div>
                <button class="botonStatusMuni" style="cursor: default">
                  <p style="color: var(--bg-popup)">
                    {{ infraction.currentState.state.state_name }}
                  </p>
                </button>
              </div>
            </div>
          </div>
          <ThemedIcon name="close" @click="closeOnOverlayClick" class="svg" />
          <div class="data-container">
            <section class="sectionInfo">
              <!--datos personas-->
              <div
                style="
                  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                  border-radius: 12px;
                  padding: 5px 5px 0px 5px;
                "
              >
                <div v-if="!isUser && !titularUndefined">
                  <div v-if="isEditingCover" class="procedure-data">
                    <button
                      class="botonStatusMuni"
                      style="
                        background: #f44336;
                        color: var(--bg-popup);
                        width: auto;
                      "
                      @click="resetInfraction()"
                    >
                      Cancelar
                    </button>
                  </div>
                  <div v-else class="procedure-data">
                    <button
                      class="botonStatusMuni"
                      style="
                        background: var(--color-success);
                        color: var(--bg-popup);
                        width: auto;
                      "
                      @click="startEditCover()"
                    >
                      Cambiar Caratula
                    </button>
                  </div>
                </div>
                <div v-if="!isEditingCover">
                  <!--datos responsables-->
                  <div v-if="!titularUndefined">
                    <div class="lineatarjetas">
                      <p class="titulomodal">Responsables Legales</p>
                    </div>
                    <div style="overflow-x: auto">
                      <table class="custom-table">
                        <thead>
                          <tr>
                            <th>Responsabilidad</th>
                            <th>CUIL</th>
                            <th v-if="!isUser">Nombre</th>
                            <th v-if="!isUser">Apellido</th>
                            <th v-if="!isUser">Domicilio</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Titular</td>
                            <td>
                              <div
                                @click="
                                  isUser
                                    ? null
                                    : searchHistory(
                                        infraction.act.infractor_cuil,
                                        true,
                                      )
                                "
                                :style="{ cursor: isUser ? 'auto' : 'pointer' }"
                              >
                                {{ infraction.act.infractor_cuil }}
                              </div>
                            </td>
                            <td v-if="!isUser">
                              {{ infraction?.infractor_name }}
                            </td>
                            <td v-if="!isUser">
                              {{ infraction?.infractor_lastname }}
                            </td>
                            <td v-if="!isUser">
                              {{ infraction?.infractor_address }}
                            </td>
                          </tr>
                          <tr>
                            <td>Infractor</td>
                            <td>
                              <div
                                @click="
                                  isUser
                                    ? null
                                    : searchHistory(
                                        infraction.act.infractor2_cuil,
                                      )
                                "
                                :style="{ cursor: isUser ? 'auto' : 'pointer' }"
                              >
                                {{ infraction.act.infractor2_cuil }}
                              </div>
                            </td>
                            <td v-if="!isUser">
                              {{ infraction?.infractor2_name }}
                            </td>
                            <td v-if="!isUser">
                              {{ infraction?.infractor2_lastname }}
                            </td>
                            <td v-if="!isUser">
                              {{ infraction?.infractor2_address }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <!--titular no cargado-->
                  <div v-else class="data-container">
                    <div class="lineatarjetas">
                      <p class="titulomodal">Datos Titular</p>
                      <div class="linea-auto-oscurita"></div>
                    </div>
                    <div class="user-data-container">
                      <div class="user-data">
                        <div>
                          <b class="user-text">CUIL:</b>
                          <p class="user-info">
                            <input
                              type="text"
                              v-model="infraction.act.infractor_cuil"
                              :class="{ invalid: !isValidCuil }"
                            />
                          </p>
                        </div>
                        <div>
                          <b class="user-text">Nombre:</b>
                          <p class="user-info">
                            <input
                              type="text"
                              :disabled="existsTitular"
                              v-model="infraction.infractor_name"
                              :class="{ invalid: !isValidName }"
                            />
                          </p>
                        </div>
                        <div>
                          <b class="user-text">Apellido:</b>
                          <p class="user-info">
                            <input
                              type="text"
                              :disabled="existsTitular"
                              v-model="infraction.infractor_lastname"
                              :class="{ invalid: !isValidLastName }"
                            />
                          </p>
                        </div>
                      </div>
                      <div
                        class="user-data secondColumn"
                        style="justify-content: none"
                      >
                        <div>
                          <b class="user-text">Domicilio:</b>
                          <p class="user-info">
                            <input
                              type="text"
                              :disabled="existsTitular"
                              v-model="infraction.infractor_address"
                              :class="{ invalid: !isValidAddress }"
                            />
                          </p>
                        </div>
                        <div v-if="!existsTitular">
                          <b class="user-text">email:</b>
                          <p class="user-info">
                            <input
                              type="text"
                              v-model="infraction.infractor_email"
                              :class="{ invalid: !isValidEmail }"
                            />
                          </p>
                        </div>
                        <div class="submitTDiv">
                          <button
                            class="botonStatusMuni"
                            style="width: auto; margin-top: 25px"
                            :disabled="!isTitularValid"
                            @click="submitTitularAssigned"
                          >
                            <p style="color: var(--bg-popup)">
                              guardar titular
                            </p>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="data-container">
                  <div class="lineatarjetas">
                    <p class="titulomodal">Datos Titular</p>
                    <div class="linea-auto-oscurita"></div>
                  </div>
                  <div class="user-data">
                    <b class="user-text">CUIL:</b>
                    <p class="user-info">
                      <input
                        type="text"
                        v-model="infraction.act.infractor_cuil"
                        :class="{ invalid: !isValidCuil }"
                      />
                    </p>
                    <b class="user-text">Nombre:</b>
                    <p class="user-info">
                      <input
                        type="text"
                        :disabled="existsTitular"
                        v-model="infraction.infractor_name"
                        :class="{ invalid: !isValidName }"
                      />
                    </p>
                    <b class="user-text">Apellido:</b>
                    <p class="user-info">
                      <input
                        type="text"
                        :disabled="existsTitular"
                        v-model="infraction.infractor_lastname"
                        :class="{ invalid: !isValidLastName }"
                      />
                    </p>
                    <b class="user-text">Domicilio:</b>
                    <p class="user-info">
                      <input
                        type="text"
                        :disabled="existsTitular"
                        v-model="infraction.infractor_address"
                        :class="{ invalid: !isValidAddress }"
                      />
                    </p>
                    <b class="user-text" v-if="!existsTitular">Email*:</b>
                    <p class="user-info">
                      <input
                        v-if="!existsTitular"
                        type="text"
                        v-model="infraction.infractor_email"
                        :class="{ invalid: !isValidEmail }"
                      />
                    </p>
                    <b class="user-text">Motivo*:</b>
                    <p class="user-info">
                      <textarea
                        v-model="motive"
                        :class="{ invalid: !isValidMotive }"
                        aria-multiline="true"
                        style="margin-bottom: 0px"
                      ></textarea>
                    </p>
                    <div>
                      <p><b>Adjuntar comprobante:</b></p>
                      <div class="container-input">
                        <input
                          v-show="false"
                          type="file"
                          id="filesMult"
                          @change="handleFileUpload"
                          class="hidden-input"
                          clickable="true"
                        />
                        <label for="filesMult" style="color: var(--bg-popup)"
                          >Insertar Archivo</label
                        >
                      </div>
                      <ul>
                        <li
                          v-for="(file, index) in files"
                          :key="index"
                          style="display: flex"
                        >
                          {{ file.name }}
                          <button @click="popFile(index)" class="button-round">
                            X
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    v-if="isEditingCover"
                    class="procedure-data"
                    style="margin-bottom: 5px"
                  >
                    <button
                      class="botonStatusMuni"
                      style="
                        background: var(--color-success);
                        color: var(--bg-popup);
                        margin-top: 1rem;
                      "
                      :disabled="!isFormValid"
                      @click="submitCoverUpdated"
                    >
                      Guardar Titular
                    </button>
                  </div>
                </div>
              </div>
              <!--info-->
              <div
                style="
                  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                  border-radius: 12px;
                  margin: 10px 0px;
                  padding: 5px 5px 0px 5px;
                "
              >
                <div class="lineatarjetas">
                  <p class="titulomodal" style="margin-bottom: 15px">
                    Información de la Infracción:
                  </p>
                </div>
                <div class="procedure-data-container">
                  <div class="procedure-data">
                    <div class="procedure-data">
                      <p>
                        <b class="user-text">Descripción</b>
                      </p>
                      <p class="user-textAnswer" style="word-break: break-all">
                        {{ infraction?.act.description }}
                      </p>
                    </div>
                    <div class="procedure-data">
                      <p>
                        <b class="user-text">Dirección de Infracción</b>
                      </p>
                      <p class="user-textAnswer" style="word-break: break-all">
                        {{ infraction?.act.fault_address }}
                      </p>
                    </div>
                    <div class="procedure-data">
                      <p>
                        <b class="user-text">Dominio</b>
                      </p>
                      <p class="user-textAnswer" style="word-break: break-all">
                        {{ infraction?.act.plate }}
                      </p>
                    </div>
                    <div class="procedure-data">
                      <p>
                        <b class="user-text">Vehiculo</b>
                      </p>
                      <p
                        v-if="isVehicleValidO"
                        class="user-textAnswer"
                        style="word-break: break-all"
                      >
                        {{ infraction?.act.vehicle }},
                        {{ infraction?.act.brand }}
                      </p>
                      <div v-else>
                        <b class="user-text">Tipo:</b>
                        <p class="user-info" style="word-break: break-all">
                          <input
                            type="text"
                            v-model="infraction.act.vehicle"
                            :class="{ invalid: !isValidVehicle }"
                          />
                        </p>
                        <b class="user-text">Marca:</b>
                        <p class="user-info" style="word-break: break-all">
                          <input
                            type="text"
                            v-model="infraction.act.brand"
                            :class="{ invalid: !isValidBrand }"
                          />
                        </p>
                        <b class="user-text">Modelo:</b>
                        <p class="user-info" style="word-break: break-all">
                          <input
                            type="number"
                            v-model="infraction.act.model"
                            :class="{ invalid: !isValidModel }"
                          />
                        </p>
                        <b class="user-text">Color:</b>
                        <p class="user-info" style="word-break: break-all">
                          <input
                            type="string"
                            v-model="infraction.act.color"
                            :class="{ invalid: !isValidColor }"
                          />
                        </p>
                        <div class="submitTDiv">
                          <button
                            class="botonStatusMuni"
                            style="width: auto; margin-top: 25px"
                            :disabled="
                              !ValidOriginalTitular() || !isVehicleValidC
                            "
                            @click="submitVehicleAssigned"
                          >
                            <p style="color: var(--bg-popup)">
                              guardar vehiculo
                            </p>
                          </button>
                        </div>
                      </div>
                      <!-- esto es porque para crear un nuevo infractor con los datos mas actuales de la patente es obligatorio el cuil del titular-->
                      <span
                        v-if="
                          !ValidOriginalTitular() && !ValidOriginalVehicle()
                        "
                        class="error-text"
                        >Necesita completar los datos del titular primero*</span
                      >
                    </div>
                    <div
                      v-if="infraction.files.length > 0"
                      class="procedure-data"
                    >
                      <p>
                        <b class="user-text">Archivos adjuntos</b>
                      </p>
                      <a
                        v-for="(file, index) in infraction.files"
                        :key="index"
                        :href="file.url"
                        target="_blank"
                      >
                        <p
                          class="user-textAnswer"
                          style="word-break: break-all; margin: 3px"
                        >
                          Archivo {{ index + 1 }}
                        </p>
                      </a>
                    </div>
                  </div>
                  <div class="procedure-data">
                    <div
                      style="
                        display: flex;
                        flex-direction: row;
                        justify-content: start;
                      "
                    >
                      <p>
                        <b class="user-text">Faltas</b>
                      </p>
                      <div v-if="!isUser">
                        <div v-if="isEditing" class="procedure-data">
                          <button
                            class="botonStatusMuni"
                            style="background: #f44336; color: var(--bg-popup)"
                            @click="resetFaults()"
                          >
                            Cancelar
                          </button>
                        </div>
                        <div v-else class="procedure-data">
                          <button
                            class="botonStatusMuni"
                            style="
                              background: var(--color-success);
                              color: var(--bg-popup);
                            "
                            @click="startEditing()"
                          >
                            Editar
                          </button>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="isEditing"
                      style="
                        display: flex;
                        flex-direction: row;
                        justify-content: start;
                      "
                    >
                      <!-- Select para agregar faltas -->
                      <div
                        style="
                          position: relative;
                          max-width: 900px;
                          width: 60%;
                          min-width: 250px;
                        "
                      >
                        <!-- Input para buscar -->
                        <input
                          v-model="searchQuery"
                          type="text"
                          placeholder="Buscar falta..."
                          class="form-select"
                          ref="searchInput"
                          style="width: 100%; padding: 8px"
                          @focus="showDropdown = true"
                          @blur="hideDropdownWithDelay"
                        />

                        <!-- Dropdown personalizado -->
                        <ul
                          v-if="showDropdown"
                          class="dropdown-list"
                          style="
                            list-style: none;
                            padding: 0;
                            margin: 0;
                            position: absolute;
                            width: 100%;
                            background: var(--bg-popup);
                            border: 1px solid #ccc;
                            max-height: 200px;
                            overflow-y: auto;
                            z-index: 500;
                          "
                        >
                          <li
                            v-for="fault in filteredFaults"
                            :key="fault.id"
                            @mousedown.prevent="addFault(fault)"
                            :style="{
                              padding: '8px',
                              cursor: isFaultAdded(fault.id)
                                ? 'cursor'
                                : 'pointer',
                              background: isFaultAdded(fault.id)
                                ? '#f5f5f5'
                                : 'white',
                              color: isFaultAdded(fault.id) ? '#aaa' : 'black',
                            }"
                          >
                            {{ fault.code }} -
                            {{ truncatedMessage(fault.description) }}
                          </li>

                          <li
                            v-if="filteredFaults.length === 0"
                            style="padding: 8px; color: #999"
                          >
                            No hay coincidencias
                          </li>
                        </ul>
                      </div>
                    </div>
                    <table class="custom-table">
                      <thead>
                        <tr>
                          <th>Codigo</th>
                          <th>Descripcion</th>
                          <th v-if="!isUser">importe</th>
                          <th v-if="!isUser && isEditing">
                            Aplica Maximo imponible
                          </th>
                          <th v-if="isEditing">Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in infraction.faults"
                          :key="index"
                        >
                          <td>{{ item.fault.code }}</td>
                          <td>{{ item.fault.description }}</td>
                          <td v-if="!isUser">
                            ${{ formatPrice(calculateFault(item)) }}
                          </td>
                          <td v-if="!isUser && isEditing">
                            <label
                              class="switch"
                              :class="{ 'pointer-cursor': isEditing }"
                            >
                              <input
                                type="checkbox"
                                v-model="item.use_maximum"
                                :disabled="!isEditing"
                              />
                              <span class="slider round"></span>
                            </label>
                          </td>
                          <td v-if="isEditing">
                            <button
                              @click="removeFault(index)"
                              class="botonStatusMuni remove-button"
                            >
                              Eliminar
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div v-if="!isUser" class="procedure-data">
                      <p>
                        <b class="user-text">Costos administrativos</b>
                        ${{
                          formatPrice(
                            infraction.calculationRule.administrative_costs,
                          )
                        }}
                      </p>
                    </div>
                    <div
                      v-if="originalInfra.apply_discount || isEditing"
                      style="display: flex; flex-direction: row"
                    >
                      <div class="procedure-data">
                        <p>
                          <b class="user-text">Aplica Descuento de</b> ${{
                            formatPrice(discountAmount)
                          }}
                        </p>
                      </div>
                      <label
                        class="switch"
                        v-if="isEditing"
                        :class="{ 'pointer-cursor': isEditing }"
                      >
                        <input
                          type="checkbox"
                          v-model="infraction.apply_discount"
                          :disabled="!isEditing"
                        />
                        <span class="slider round"></span>
                      </label>
                    </div>
                    <div v-if="isEditing">
                      <p>
                        <b class="user-text"
                          >Descuentos y Recargos extraordinarios</b
                        >
                      </p>
                      <div class="extraordinaryDiscounts">
                        <p><b class="user-text">descuento por porcentaje</b></p>
                        <p
                          class="user-info"
                          style="word-break: break-all; margin-left: 5px"
                        >
                          <input
                            class="inputDiscount"
                            type="text"
                            v-model="infraction.discount_percentage"
                            :class="{ invalid: !isValidPercentage }"
                            @input="validatePercentage"
                          />
                        </p>
                        <p>%</p>
                      </div>
                      <div class="extraordinaryDiscounts">
                        <p>
                          <b class="user-text">descuento o recargo por monto</b>
                          $
                        </p>
                        <p class="user-info" style="word-break: break-all">
                          <input
                            class="inputDiscount"
                            type="text"
                            v-model="infraction.discount_numeric"
                            :class="{ invalid: !isValidNumeric }"
                            @input="validateNumeric"
                          />
                        </p>
                      </div>
                    </div>
                    <div class="procedure-data">
                      <p>
                        <b class="user-text">Total</b> ${{ formatPrice(total) }}
                      </p>
                    </div>
                    <div v-if="isEditing" class="procedure-data">
                      <button
                        class="botonStatusMuni"
                        style="
                          background: var(--color-success);
                          color: var(--bg-popup);
                        "
                        @click="submitInfractionUpdated()"
                      >
                        Guardar Cambios
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="timeline-container">
                <div
                  v-for="(item, index) in combinedList"
                  :key="index"
                  class="timeline-item"
                >
                  <!-- Línea de conexión -->
                  <div
                    class="timeline-line"
                    v-if="index !== combinedList.length - 1"
                  ></div>

                  <!-- Punto de inicio -->
                  <div
                    class="timeline-point"
                    @click="toggleExpand(index)"
                  ></div>

                  <!-- Tarjeta del historial -->
                  <div
                    :class="[
                      'timeline-card',
                      { expanded: expandedIndex === index },
                    ]"
                    @click="toggleExpand(index)"
                  >
                    <div class="timeline-header">
                      <p class="timeline-title">
                        <b>Origen:</b>
                        <span v-if="item.type === 'state'"
                          >Cambio de Estado</span
                        >
                        <span v-else-if="item.type === 'coverChange'"
                          >Cambio de Carátula</span
                        >
                        <span v-else-if="item.type === 'observation'"
                          >Observación</span
                        >
                        <span v-else>Tipo Desconocido</span>
                      </p>
                      <div
                        style="display: flex; width: 20%"
                        :style="{
                          justifyContent: item.failed_communication
                            ? 'space-between'
                            : 'flex-end',
                        }"
                      >
                        <img
                          src="@/assets/images/tarea-card.svg"
                          v-if="item.failed_communication"
                        />
                        <span class="timeline-date" style="right: 0px">{{
                          formatDate(item.createdAt)
                        }}</span>
                      </div>
                    </div>

                    <!-- Contenido expandido -->
                    <div
                      v-show="expandedIndex === index"
                      class="timeline-content"
                    >
                      <div v-if="item.type === 'state'">
                        <p><b>Estado:</b> {{ item.state?.state_name }}</p>
                        <p v-if="item.comment">
                          <b>Comentario:</b> {{ item.comment }}
                        </p>
                        <div v-if="item.files.length > 0">
                          <p><b>Archivos Adjuntos:</b></p>
                          <a
                            v-for="(file, i) in item.files"
                            :key="i"
                            :href="file.url"
                            target="_blank"
                            class="file-link"
                          >
                            Archivo {{ i + 1 }}
                          </a>
                        </div>
                        <p v-if="item.physicalNotification">
                          <b>Notificación por correo:</b>
                        </p>
                        <div v-if="item.physicalNotificationFiles.length > 0">
                          <a
                            v-for="(file, i) in item.physicalNotificationFiles"
                            :key="i"
                            :href="file.url"
                            target="_blank"
                            class="file-link"
                          >
                            Archivo {{ i + 1 }}
                          </a>
                        </div>
                      </div>

                      <div v-else-if="item.type === 'coverChange'">
                        <p><b>Comentario:</b> {{ item.comment }}</p>
                        <p v-if="item.infractor_cuil">
                          <b>Titular actual CUIL:</b> {{ item.infractor_cuil }}
                        </p>
                        <p v-if="item.infractor2_cuil">
                          <b>Titular anterior CUIL:</b>
                          {{ item.infractor2_cuil }}
                        </p>
                        <div v-if="item.files?.length > 0">
                          <p><b>Archivos Adjuntos:</b></p>
                          <a
                            v-for="(file, i) in item.files"
                            :key="i"
                            :href="file.url"
                            target="_blank"
                            class="file-link"
                          >
                            Archivo {{ i + 1 }}
                          </a>
                        </div>
                      </div>

                      <div v-else-if="item.type === 'observation'">
                        <p><b>Motivo:</b> {{ item.comment }}</p>
                        <p v-if="item.cuil_person">
                          <b>Persona CUIL:</b> {{ item.cuil_person }}
                        </p>
                        <div v-if="item.files?.length > 0">
                          <p><b>Archivos Adjuntos:</b></p>
                          <a
                            v-for="(file, i) in item.files"
                            :key="i"
                            :href="file.url"
                            target="_blank"
                            class="file-link"
                          >
                            Archivo {{ i + 1 }}
                          </a>
                        </div>
                      </div>

                      <!--<div v-if="item.failed_communication">
                        <p><b>Adjuntar Notificacion física:</b></p>
                        <div class="container-input">
                          <input v-show="false" type="file" id="filesMult" @change="handleFileUpload"
                            class="hidden-input" clickable="true" />
                          <label for="filesMult" style="color: var(--bg-popup);">Insertar Archivo</label>
                        </div>
                        <ul>
                          <li v-for="(file, index) in files" :key="index" style="display: flex;">
                            {{ file.name }} <button @click="popFile(index)" class="button-round">X</button>
                          </li>
                        </ul>
                        <button class="container-input" @click="saveManualCommunication(item)"
                          :disabled="files.length < 1">guardar</button>
                      </div>-->
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="errorTransition">
                <span class="error-text">{{ errorTransitionMessage }}</span>
              </div>
              <!-- BOTONES PARA ACCIONES  -->
              <div
                v-if="possiblesStates.length > 0 || unarchiveAvailable"
                class="footer"
              >
                <input
                  v-for="(item, index) in possiblesStates"
                  :key="index"
                  class="boton-action"
                  type="button"
                  :style="{ background: `${getStateColor(item.state_name)}` }"
                  :value="getStateAction(item.state_name)"
                  @click="ModalTransiton(item)"
                />
                <input
                  v-if="!isUser && !unarchiveAvailable"
                  class="boton-action"
                  type="button"
                  :style="{ background: `#009688` }"
                  value="OBSERVACION"
                  @click="ModalObservation()"
                />
                <input
                  v-if="unarchiveAvailable"
                  class="boton-action"
                  type="button"
                  :style="{ background: `#8bc34a` }"
                  value="DESARCHIVAR"
                  @click="unarchiveInfraction()"
                />
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--modal transition-->
  <div
    class="modalOverlay"
    v-if="modalTransitionV"
    @click="closeOnOverlayClick"
  >
    <div class="modalTarea" @click.stop>
      <div class="modal-content-task">
        <div class="modal-top-tarea">
          <h5 class="titulomodal-tasks">
            {{ getStateAction(selectedState.state_name) }} - ACTA:
            {{ infraction.act.act_number }}
          </h5>
          <ThemedIcon name="close" @click="closeTransition" class="svg-tarea" />
        </div>
        <TransitionModalComponent
          ref="modalFinalizedComponent"
          :submitFunction="submitStateUpdate"
          :infra="infraction"
          :closeFunction="closeTransitionAndFetch"
          :succes="succesTransition"
          :inserted="transition"
        />
      </div>
    </div>
  </div>
  <!--modal observacion-->
  <div
    class="modalOverlay"
    v-if="modalObservation"
    @click="closeOnOverlayClick"
  >
    <div class="modalTarea" @click.stop>
      <div class="modal-content-task">
        <div class="modal-top-tarea">
          <h5 class="titulomodal-tasks">
            OBSERVACION - ACTA: {{ infraction.act.act_number }}
          </h5>
          <ThemedIcon name="close" @click="closeTransition" class="svg-tarea" />
        </div>
        <ObservationModalComponent
          :submitFunction="submitObservation"
          :infra="infraction"
          :closeFunction="closeTransitionAndFetch"
          :succes="succesObservation"
          :inserted="transition"
        />
      </div>
    </div>
  </div>
  <!--modal espera-->
  <div v-if="loading" class="modalOverlay">
    <div class="fondoLoader">
      <div
        class="modal fade"
        id="exampleModalToggle"
        aria-hidden="true"
        aria-labelledby="exampleModalToggleLabel"
        tabindex="-1"
        :class="{ show: loading }"
        style="display: block"
        @click="cerrarAdvertencia"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content modaldos">
            <p style="margin-bottom: 24px">
              Por favor aguarde. {{ loadingModalMessage ?? "" }}
            </p>
            <div
              style="
                display: flex;
                flex-direction: row;
                justify-content: center;
              "
            >
              <span class="loader"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <HistorialModalComponent
    v-if="modalHistorial.visible"
    :modal="modalHistorial"
    @close="closeTransition"
  />
</template>

<script setup>
import store from "@/store/index";
import StateService from "@/services/infractions/stateService";
import {
  defineProps,
  ref,
  onUpdated,
  reactive,
  onMounted,
  computed,
  watch,
} from "vue";
import TransitionModalComponent from "./TransitionModalComponent.vue";
import StatesHandlers from "@/services/helpers/statesHandlers";
import FaultService from "@/services/infractions/faultsService";
import InfractionService from "@/services/infractions/infractionService";
import StateTransitionService from "@/services/infractions/stateTransitionService";
import InfractorService from "@/services/infractions/infractorService";
import PDFDocument from "@/services/pdf/pdfDocument";
import LoadingMessages from "@/services/helpers/loadingMessages";
import GeneralFunctions from "@/services/helpers/generalFunctions";
import { useToast } from "vue-toastification";
import ObservationModalComponent from "./ObservationModalComponent.vue";
import HistorialModalComponent from "./historial/HistorialModalComponent.vue";
import ThemedIcon from "@/components/Utils/ThemedIcon.vue";
//import StateTransitionService from '@/services/infractions/stateTransitionService';

const toast = useToast();

const props = defineProps({
  obj: {
    type: Object,
    required: true,
  },
  close: {
    type: Function,
    required: false,
  },
  reload: {
    type: Function,
    required: false,
  },
  isEvent: {
    type: Boolean,
    required: false,
  },
  eventReceived: {
    type: Function,
    required: false,
  },
});

const modalTransitionV = ref(false);
const isEditing = ref(false);
const isEditingCover = ref(false);
const loading = ref(false);
const propsLoaded = ref(false);
const succesTransition = ref(false);
const succesObservation = ref(false);
const existsTitular = ref(false);
const existsInfractor = ref(false);
const isInternalNumberAvailable = ref(true);
const errorTransition = ref(false);
const modalObservation = ref(false);
const inOfi = ref(false);

let functionTo = null;

const selectedFile = ref(null);
const files = reactive([]);
const errorTransitionMessage = ref("");
const loadingModalMessage = ref("");
const transition = ref({});
const motive = ref("");
const subtittle = ref("");
const message = ref("");
let originalInfra = reactive({});
const originalFaults = reactive([]);
const availablesFaultCodes = reactive([]);
const infraction = ref({});
const possiblesStates = ref({});
const selectedFaultId = ref("");
const searchQuery = ref("");
const selectedState = ref({
  createdAt: "",
  id: null,
  role_admitted: "",
  state_name: "",
  updatedAt: "",
});
const records = ref({});
const modalHistorial = reactive({
  visible: false,
  loading: false,
  data: [],
  titulo: "",
});

const actionMap = {
  LABRADA: StatesHandlers.handleLabrada,
  NOTIFICADA: StatesHandlers.handleNotificada,
  DESCARGO: StatesHandlers.handleDescargo,
  SENTENCIA: StatesHandlers.handleSentencia,
  RECURRIDA: StatesHandlers.handleRecurrida,
  "SENTENCIA FIRME": StatesHandlers.handleSentenciaFirme,
  PAGADA: StatesHandlers.handlePagada,
  DESESTIMADA: StatesHandlers.handleCancelada,
  ARCHIVADA: StatesHandlers.handleArchivada,
  ANULADA: StatesHandlers.handleAnulada,
};

infraction.value = props.obj.infraction;
possiblesStates.value = props.obj.states;

const expandedIndex = ref(null);
const toggleExpand = (index) => {
  expandedIndex.value = expandedIndex.value === index ? null : index;
};

const isUser = computed(() => {
  const user = store.state.user;
  const multas = user.muniAreas
    ? user.muniAreas.some((item) => item.area.area_name === "MULTAS")
    : false;
  return !user.muniAreas && !multas;
  //return (user.muniAreas.some(item => item.area.area_name === "INSPECTORES") && window.innerWidth <= 770)
});

/*const ventana = computed(() => {
    return window.innerWidth
})*/

const closeOnOverlayClick = () => {
  props.reload();
  propsLoaded.value = false;
  props.close();
};

const tryDownload = async () => {
  await PDFDocument.DownloadInfoTest(deepClone(infraction.value));
};

const fetchFaults = async () => {
  const response = await FaultService.getAllFaults();
  if (response.success) {
    availablesFaultCodes.length = 0;
    availablesFaultCodes.push(...response.data);
  }
};

const fetchInfractionById = async (id) => {
  const response = await InfractionService.getInfractionById(id);
  if (response.success) {
    infraction.value = response.data.data.infraction;
    possiblesStates.value = response.data.data.states;
  }
};

const combinedList = computed(() => {
  const states = infraction.value.statesInfraction.map((item) => ({
    ...item,
    type: "state",
  }));
  const covers = infraction.value.coverChanges.map((item) => ({
    ...item,
    type: "coverChange",
  }));
  const observations = infraction.value.observations.map((item) => ({
    ...item,
    type: "observation",
  }));
  return [...states, ...covers, ...observations].sort(
    (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
  );
});

// Reglas de validación
const namePattern = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ ]{1,25}$/;
const cuilPattern = /^\d{11}$/;
const addressPattern = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9,. ]{1,50}$/;
const motivePattern = /^[\s\S]{1,500}$/;
const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const numberPattern = /^\d{1,6}$/;
const platePattern = /^[A-Za-z0-9]+( [A-Za-z0-9]+)?$/;

//para desarchivar
const unarchiveAvailable = computed(() => {
  const forbiddenStates = [7];
  const hasForbiddenState = infraction.value.statesInfraction.some(
    (stateInfraction) => forbiddenStates.includes(stateInfraction.state.id),
  );
  return infraction.value.currentState.state.id === 9 && !hasForbiddenState;
});

const unarchiveInfraction = async () => {
  loading.value = true;
  getMessageForModal("unarchiveInfraction");

  const response = await StateTransitionService.unarchiveInfraction(
    infraction.value.id,
  );

  if (response.success) {
    await fetchInfractionById(infraction.value.id);
    saveOriginalInfra();
    props.reload();
  } else {
    // console.log("status ", response.status);
    // console.log("mensaje ", response.message)
    toast.error("Hubo un error al actualizar la infracción.");
  }

  loading.value = false;
  clearMessageForModal();
};

//para buscar el historial
const searchHistory = async (cuil, isTitular = false) => {
  if (!cuil) return;

  modalHistorial.visible = true;
  modalHistorial.loading = true;
  modalHistorial.titulo = isTitular
    ? "Historial del Titular"
    : "Historial del Infractor";

  const { infractor_cuil, infractor2_cuil } = infraction.value.act || {};
  const sameCuil = infractor_cuil === infractor2_cuil;

  // Si es búsqueda para infractor y los CUIL son diferentes
  if (!isTitular && !sameCuil) {
    if (!records.value?.infractor) {
      try {
        const response = await InfractionService.getHistoryByCuil(cuil);
        records.value.infractor = response?.success ? response.data : null;
        modalHistorial.data = response?.success ? response.data : [];
      } catch {
        records.value.infractor = null;
        modalHistorial.data = null;
        modalHistorial.visible = false;
        toast.error("Error al obtener historial del infractor");
      }
    }
    modalHistorial.loading = false;
    return;
  }

  // Para titular o CUILs iguales
  if (!records.value?.titular) {
    try {
      const response = await InfractionService.getHistoryByCuil(cuil);
      const result = response?.success ? response.data : null;
      records.value.titular = result;
      if (sameCuil) records.value.infractor = result;
      modalHistorial.data = response?.success ? response.data : [];
    } catch {
      records.value.titular = null;
      if (sameCuil) records.value.infractor = null;
      modalHistorial.data = null;
      modalHistorial.visible = false;
      toast.error("Error al obtener historial");
    }
  } else if (sameCuil) {
    records.value.infractor = records.value.titular;
  } else {
    modalHistorial.data = isTitular
      ? records.value.titular
      : records.value.infractor;
  }

  modalHistorial.loading = false;
};

//validaciones para descuentos o recargos extraordinarios
const numPattern = /^[0-9]+$/;
const numericPattern = /^-?[0-9]+$/;

const isValidPercentage = computed(() => {
  if (!infraction.value.discount_percentage) return true;
  return numPattern.test(infraction.value.discount_percentage);
});

const isValidNumeric = computed(() => {
  if (!infraction.value.discount_numeric) return true;
  return numericPattern.test(infraction.value.discount_numeric);
});

const validatePercentage = () => {
  if (infraction.value.discount_numeric) {
    infraction.value.discount_numeric = null; // Si hay un valor en discount_numeric, lo limpiamos
  }
  if (infraction.value.discount_percentage) {
    infraction.value.discount_percentage = infraction.value.discount_percentage
      .replace(/[^0-9]/g, "")
      .slice(0, 2);

    const value = parseInt(infraction.value.discount_percentage);
    if (value < 1 || value > 99) {
      infraction.value.discount_percentage = "";
    }
  }
};

const validateNumeric = () => {
  if (infraction.value.discount_percentage) {
    infraction.value.discount_percentage = null; // Si hay un valor en discount_percentage, lo limpiamos
  }
  if (infraction.value.discount_numeric) {
    infraction.value.discount_numeric =
      infraction.value.discount_numeric.replace(/[^0-9-]/g, "");

    let value = parseInt(infraction.value.discount_numeric);

    //if (value < 0 && Math.abs(value) > total.value) {
    if (value < 0 && 0 > total.value) {
      infraction.value.discount_numeric = null; // Si el descuento es mayor que el total, lo borramos
    }
  }
};

// ** Watch para actualizar y validar descuentos **
watch(
  () => [
    infraction.value.discount_percentage,
    infraction.value.discount_numeric,
    infraction.value.apply_discount,
  ],
  () => {
    if (
      infraction.value.apply_discount &&
      infraction.value.calculationRule.discount_percentage
    ) {
      const newTotal = calculateTotal();

      // Si hay un descuento numérico y supera el total, lo reseteamos
      //if (infraction.value.discount_numeric && Math.abs(infraction.value.discount_numeric) > newTotal ) {
      if (infraction.value.discount_numeric && 0 > newTotal) {
        infraction.value.discount_numeric = null;
      }
    }
  },
);

//validaciones en caso de datos faltantes
const truncateInternalNumber = () => {
  infraction.value.internal_number = infraction.value.internal_number
    ? infraction.value.internal_number.toString().slice(0, 6)
    : null;
};
const isValidInternalNumber = computed(() => {
  truncateInternalNumber();
  return infraction.value.internal_number
    ? numberPattern.test(infraction.value.internal_number)
    : false;
});
const searchingInt = ref(false);
watch(
  () => infraction.value.internal_number,
  async (newValue) => {
    if (isValidInternalNumber.value && originalInfra.internal_number < 1) {
      searchingInt.value = true;
      isInternalNumberAvailable.value = await fetchInternalNumber(newValue);
      searchingInt.value = false;
    } else {
      isInternalNumberAvailable.value = true;
    }
  },
);
const fetchInternalNumber = async (internalNumber) => {
  if (internalNumber < 1) {
    return false;
  }
  const response =
    await InfractionService.isAvailableInternalNumber(internalNumber);
  return response.success
    ? response.data
    : internalNumber.toString().length > 5
      ? true
      : false;
};
// Validaciones individuales
const isValidName = computed(() => {
  return (
    namePattern.test(infraction.value.infractor_name.trim()) &&
    !/\s{2,}/.test(infraction.value.infractor_name)
  );
});

const isValidLastName = computed(() => {
  return (
    namePattern.test(infraction.value.infractor_lastname.trim()) &&
    !/\s{2,}/.test(infraction.value.infractor_lastname)
  );
});

const isValidCuil = computed(() => {
  revisionCuil(infraction.value.act.infractor_cuil);
  return infraction.value.act.infractor_cuil
    ? cuilPattern.test(infraction.value.act.infractor_cuil)
    : false;
});

const revisionCuil = (cuil) => {
  if (cuilPattern.test(cuil)) {
    fecthUserByCuil(cuil);
  } else {
    infraction.value.infractor_name = "";
    infraction.value.infractor_lastname = "";
    infraction.value.infractor_address = "";
    existsTitular.value = false;
    existsTitular.value =
      cuil === infraction.value.infractor_cuil ? false : existsTitular.value;
    existsInfractor.value =
      cuil === infraction.value.infractor2_cuil ? false : existsInfractor.value;
  }
};

const fecthUserByCuil = async (cuil) => {
  const response = await InfractorService.getUserByCuil(cuil);
  if (!response.success) return;

  if (cuil === infraction.value.act.infractor_cuil) {
    existsTitular.value = true;
    inOfi.value = response.data.inOfi;
    infraction.value.infractor_name = response.data.name;
    infraction.value.infractor_lastname = response.data.lastname;
    infraction.value.infractor_address = response.data.address;
  }
};

const isValidAddress = computed(() => {
  upperInfractorAddress();
  return infraction.value.infractor_address
    ? addressPattern.test(infraction.value.infractor_address.trim()) &&
        !/\s{2,}/.test(infraction.value.infractor_address)
    : false;
});
const upperInfractorAddress = () => {
  infraction.value.infractor_address = infraction.value.infractor_address
    ? infraction.value.infractor_address.toUpperCase().replace(/\s{2,}/g, " ") // Reemplaza múltiples espacios consecutivos por uno
    : null;
};

const isValidMotive = computed(() => {
  return (
    motivePattern.test(motive.value.trim()) &&
    motive.value.trim().length > 0 &&
    !/^\s+$/.test(motive)
  );
});

const normalizeEmail = () => {
  infraction.value.infractor_email = infraction.value.infractor_email
    ? infraction.value.infractor_email.trim()
    : null;
};

const isValidEmail = computed(() => {
  normalizeEmail();
  return existsTitular.value
    ? true
    : infraction.value.infractor_email
      ? emailPattern.test(infraction.value.infractor_email)
      : false;
});

//valids para vehiculo
const isValidVehicle = computed(() => {
  const vehicle = infraction.value.act.vehicle
    ? infraction.value.act.vehicle.trim()
    : "";
  upperVehicle();
  return platePattern.test(vehicle); // Verifica que cumple con el patrón.
});

const upperVehicle = () => {
  if (infraction.value.act.vehicle) {
    infraction.value.act.vehicle = infraction.value.act.vehicle
      .toUpperCase()
      .trim();
  }
};

const isValidBrand = computed(() => {
  const brand = infraction.value.act.brand
    ? infraction.value.act.brand.trim()
    : "";
  upperBrand();
  return platePattern.test(brand); // Verifica que cumple con el patrón.
});

const upperBrand = () => {
  if (infraction.value.act.brand) {
    infraction.value.act.brand = infraction.value.act.brand
      .toUpperCase()
      .trim();
  }
};

const isValidColor = computed(() => {
  const color = infraction.value.act.color
    ? infraction.value.act.color.trim()
    : "";
  upperColor();
  return infraction.value.act.color ? platePattern.test(color) : true; // Verifica que cumple con el patrón.
});

const upperColor = () => {
  if (infraction.value.act.color) {
    infraction.value.act.color = infraction.value.act.color
      .toUpperCase()
      .trim();
  }
};

const isValidModel = computed(() =>
  numberPattern.test(infraction.value.act.model),
);

const ValidOriginalTitular = () => {
  return (
    originalInfra.infractor_name &&
    originalInfra.infractor_lastname &&
    originalInfra.act?.infractor_cuil &&
    originalInfra.infractor_address
  );
};

const ValidOriginalVehicle = () => {
  return (
    originalInfra.act?.vehicle &&
    originalInfra.act?.brand &&
    originalInfra.act?.model
  );
};

const isVehicleValidO = computed(() => {
  return (
    originalInfra.act?.vehicle &&
    originalInfra.act?.brand &&
    originalInfra.act?.model
  );
});

const isVehicleValidC = computed(() => {
  return (
    isValidColor.value &&
    isValidVehicle.value &&
    isValidBrand.value &&
    isValidModel.value
  );
});

// Validación del formulario completo para cover update
const isFormValid = computed(() => {
  return isValidMotive.value && isTitularValid.value;
});

const isTitularValid = computed(() => {
  return (
    isValidName.value &&
    isValidLastName.value &&
    isValidCuil.value &&
    isValidAddress.value &&
    isValidEmail.value
  );
});

const startEditCover = () => {
  saveOriginalInfra();
  isEditingCover.value = true;
};

const saveOriginalInfra = async () => {
  //console.log("guarda ori")
  //originalInfra = null;
  //originalInfra = JSON.parse(JSON.stringify(infraction.value));
  //originalInfra.act = JSON.parse(JSON.stringify(infraction.value.act))

  // Limpiar el objeto reactivo existente
  for (const key in originalInfra) {
    delete originalInfra[key];
  }

  // Copiar los nuevos valores al objeto reactivo
  Object.assign(originalInfra, JSON.parse(JSON.stringify(infraction.value)));
  originalInfra.act = JSON.parse(JSON.stringify(infraction.value.act));
};

const resetInfraction = () => {
  motive.value = "";
  infraction.value = null;
  infraction.value = JSON.parse(JSON.stringify(originalInfra));
  isEditingCover.value = false;
};

const submitInfractor = async () => {
  const titular = await InfractorService.CreateInfractor({
    plate: infraction.value.act.plate,
    email: infraction.value.infractor_email ?? "",
    cuil: infraction.value.act.infractor_cuil,
    name: infraction.value.infractor_name,
    lastname: infraction.value.infractor_lastname,
    address: infraction.value.infractor_address,
    vehicle: infraction.value.act.vehicle ?? "",
    brand: infraction.value.act.brand ?? "",
    model: infraction.value.act.model ?? null,
    color: infraction.value.act.color ?? "",
  });

  return titular;
};

const submitTitularAssigned = async () => {
  loading.value = true;
  getMessageForModal("SavingTitular");

  const titular = await submitInfractor();

  if (!titular.success) {
    // console.log("Hubo un error al crear el titular.");
    loading.value = false;
    toast.error("Hubo un error al crear el titular.");
    return;
  }

  //let body = {};

  //body.id = infraction.value.id;
  //body.infractor_cuil = infraction.value.act.infractor_cuil

  /*if (originalInfra.infractor_cuil === originalInfra.infractor2_cuil || originalInfra.infractor2_cuil === null) {
    body.infractor2_cuil = infraction.value.act.infractor_cuil
  } else {
    body.infractor2_cuil = infraction.value.act.infractor2_cuil
  }*/

  const response = await InfractionService.AssignTitular(
    infraction.value.id,
    infraction.value.act.infractor_cuil,
  );

  if (response.success) {
    titularUndefined.value = false;
    await fetchInfractionById(infraction.value.id);
    loading.value = false;
    saveOriginalInfra();
    ValidOriginalTitular();
    props.reload();
  } else {
    loading.value = false;
    // console.log("status ", response.status);
    // console.log("mensaje ", response.message)
    toast.error("Hubo un error al actualizar la infracción.");
  }
  clearMessageForModal();
};

const submitVehicleAssigned = async () => {
  loading.value = true;
  getMessageForModal("SavingVehicle");

  const titular = await submitInfractor();

  if (!titular.success) {
    // console.log("Hubo un error al crear el titular.");
    loading.value = false;
    return;
  }

  const response = await InfractionService.AssignVehicle(
    infraction.value.id,
    infraction.value.act.vehicle,
    infraction.value.act.brand,
    infraction.value.act.model,
    infraction.value.act.color,
  );

  if (response.success) {
    titularUndefined.value = false;
    await fetchInfractionById(infraction.value.id);
    saveOriginalInfra();
    props.reload();
  } else {
    // console.log("status ", response.status);
    // console.log("mensaje ", response.message)
    toast.error("Hubo un error al actualizar la infracción.");
  }

  loading.value = false;
  clearMessageForModal();
};

const submitCoverUpdated = async () => {
  if (originalInfra.act.infractor_cuil === infraction.value.act.infractor_cuil)
    return;
  loading.value = true;
  getMessageForModal("UpdatingCover");

  if (!existsTitular.value) {
    const titular = await submitInfractor();

    if (!titular.success) {
      // console.log("Hubo un error al crear el titular.");
      loading.value = false;
      toast.error("Hubo un error al crear el titular.");
      return;
    }
  }

  let body = {};

  body.id = infraction.value.id;
  body.comment = motive.value;
  body.infractor_cuil = infraction.value.act.infractor_cuil;

  if (
    originalInfra.infractor_cuil === originalInfra.infractor2_cuil ||
    originalInfra.infractor2_cuil === null
  ) {
    body.infractor2_cuil = infraction.value.act.infractor_cuil;
  } else {
    body.infractor2_cuil = infraction.value.act.infractor2_cuil;
  }

  body.cidi = store.state.CidiCookie;

  body.filesCode = crypto.randomUUID();
  if (files.length > 0) {
    const res = await postFile(body.filesCode);
    if (!res.success) {
      loading.value = false;
      toast.error("Hubo un error al subir los archivos.");
    }
  }

  const response = await InfractionService.updateCover(body);

  if (response.success) {
    motive.value = "";
    isEditingCover.value = false;
    await fetchInfractionById(infraction.value.id);
    loading.value = false;
    toast.success("Notificacion manual guardada con exito");
  } else {
    // console.log("status ", response.status);
    // console.log("mensaje ", response.message)
    // console.log("Hubo un error al actualizar la infracción.");
    loading.value = false;
    toast.error("Hubo un error al actualizar la infracción.");
  }
  clearMessageForModal();
};

const calculateFault = (fault) => {
  const [max, min] = fault.faultUnit
    ? [fault.faultUnit.max_imponible, fault.faultUnit.imponible]
    : [fault.units_amounts[0].max_imponible, fault.units_amounts[0].imponible];
  const imponible = fault.use_maximum ? max : min;

  return (
    Number(
      infraction.value.calculationRule.liters_amount *
        infraction.value.gasolinePrice.liter_value,
    ) *
    (Number(imponible) / 100)
  );
};

// Cálculo de total con reactividad
const calculateTotal = () => {
  let total = Number(infraction.value.calculationRule.administrative_costs);

  for (const fault of infraction.value.faults) {
    const [max, min] = fault.faultUnit
      ? [fault.faultUnit.max_imponible, fault.faultUnit.imponible]
      : [
          fault.units_amounts[0].max_imponible,
          fault.units_amounts[0].imponible,
        ];
    const imponible = fault.use_maximum ? max : min;

    const increment =
      Number(
        infraction.value.calculationRule.liters_amount *
          infraction.value.gasolinePrice.liter_value,
      ) *
      (imponible / 100);
    total += increment;
  }

  // Aplicar descuento porcentual si está habilitado y presente
  if (
    infraction.value.apply_discount &&
    infraction.value.calculationRule.discount_percentage
  ) {
    const discount =
      (total * Number(infraction.value.calculationRule.discount_percentage)) /
      100;
    total -= discount;
  }

  // Aplicar descuento/recargo numérico si está presente y el descuento porcentual no
  if (
    numericPattern.test(infraction.value.discount_numeric) &&
    infraction.value.discount_numeric
  ) {
    total += Number(infraction.value.discount_numeric);
  }

  // Aplicar descuento porcentual si está presente y el descuento/recargo numérico no
  if (infraction.value.discount_percentage) {
    const discount =
      (total * Number(infraction.value.discount_percentage)) / 100;
    total -= discount;
  }

  return total;
};

const total = computed(() => calculateTotal());

// Cálculo del monto del descuento
const discountAmount = computed(() => {
  let baseTotal = Number(infraction.value.calculationRule.administrative_costs);

  for (const fault of infraction.value.faults) {
    const [max, min] = fault.faultUnit
      ? [fault.faultUnit.max_imponible, fault.faultUnit.imponible]
      : [
          fault.units_amounts[0].max_imponible,
          fault.units_amounts[0].imponible,
        ];
    const imponible = fault.use_maximum ? max : min;

    const increment =
      Number(
        infraction.value.calculationRule.liters_amount *
          infraction.value.gasolinePrice.liter_value,
      ) *
      (imponible / 100);
    baseTotal += increment;
  }

  return (
    (baseTotal * Number(infraction.value.calculationRule.discount_percentage)) /
    100
  );
});

const formatPrice = (price) => {
  const costAsNumber = parseFloat(price);

  return new Intl.NumberFormat("es-AR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(costAsNumber);
};

/*const getFileName = (url) => {
  // Eliminamos el protocolo y el path hasta el nombre del archivo
  const fileNameWithExtension = url.split('/').pop();

  // Encontramos el último punto (extensión) y extraemos la parte final del nombre
  const lastIndexOfDot = fileNameWithExtension.lastIndexOf('.');
  const fileNameWithoutFirstUnderscore = fileNameWithExtension.substring(fileNameWithExtension.indexOf('_') + 1, lastIndexOfDot);

  return fileNameWithoutFirstUnderscore + fileNameWithExtension.substring(lastIndexOfDot);
}*/

const removeFault = (index) => {
  infraction.value.faults.splice(index, 1);
};

const addFault = (fault) => {
  selectedFaultId.value = fault.id;
  if (!selectedFaultId.value) return;

  // Verifica si la falta ya está en la lista actual
  const alreadyAdded = infraction.value.faults.some(
    (fault) => fault.fault.id === selectedFaultId.value,
  );

  if (!alreadyAdded) {
    const faultToAdd = availablesFaultCodes.find(
      (fault) => fault.id === selectedFaultId.value,
    );
    const existingFault = originalFaults.find(
      (faultIn) => faultIn.fault.id === selectedFaultId.value,
    );
    infraction.value.faults.push({
      id: existingFault ? existingFault.id : null,
      fault: faultToAdd,
      faultUnit: faultToAdd.units_amounts[0], // Asigna el unitario
      use_maximum: existingFault ? existingFault.use_maximum : false, // Asigna el estado si existe en originales, de lo contrario false
    });
  }

  // Reinicia el valor del select
  selectedFaultId.value = "";
  searchQuery.value = "";
  showDropdown.value = false;

  //deselecciona el input
  if (searchInput.value) {
    searchInput.value.blur();
  }
};

const showDropdown = ref(false);
const searchInput = ref(null); // Crea la referencia al input de busqueda de faults
const hideDropdownWithDelay = () => {
  setTimeout(() => {
    showDropdown.value = false;
  }, 200);
};

// Verifica si una falta ya está agregada (para deshabilitar la opción)
const isFaultAdded = (faultId) => {
  return infraction.value.faults.some((fault) => fault.fault.id === faultId);
};

const filteredFaults = computed(() => {
  return availablesFaultCodes.filter(
    (fault) =>
      fault.description
        .toLowerCase()
        .includes(searchQuery.value.toLowerCase()) ||
      fault.code.toString() === searchQuery.value,
  );
});

const truncateText = (text, length) => {
  return text.length > length ? text.substring(0, length) + "..." : text;
};

const truncatedMessage = (message) => {
  if (!message) return "";
  return truncateText(message, 25);
};

// Restaurar faltas originales al cancelar
const startEditing = () => {
  originalFaults.length = 0;
  originalFaults.push(
    ...infraction.value.faults.map((fault) => deepClone(fault)),
  );
  isEditing.value = true;
};

// Restaurar faltas originales al cancelar
const resetFaults = () => {
  infraction.value.apply_discount = originalInfra.apply_discount;
  infraction.value.discount_numeric = originalInfra.discount_numeric ?? null;
  infraction.value.discount_percentage =
    originalInfra.discount_percentage ?? null;
  infraction.value.faults.length = 0;
  infraction.value.faults.push(
    ...originalFaults.map((fault) => deepClone(fault)),
  );
  isEditing.value = false;
};

// Clonar profundamente un objeto
const deepClone = (obj) => {
  return JSON.parse(JSON.stringify(obj));
};

const submitInfractionUpdated = async () => {
  if (infraction.value.discount_numeric && infraction.value.discount_percentage)
    return;
  loading.value = true;
  getMessageForModal("UpdatingValue");
  const faults = infraction.value.faults.map((fault) => {
    return {
      id: fault.id ? fault.id : null,
      faultId: fault.fault.id,
      useMaximum: fault.use_maximum,
    };
  });
  let body = {
    id: infraction.value.id,
    apply_discount: infraction.value.apply_discount,
    faults: faults,
  };
  if (infraction.value.discount_numeric) {
    body = {
      ...body,
      discount_numeric: parseInt(infraction.value.discount_numeric, 10),
    };
  }
  if (infraction.value.discount_percentage) {
    body = {
      ...body,
      discount_percentage: parseInt(infraction.value.discount_percentage, 10),
    };
  }
  const response = await InfractionService.updateInfraction(body);

  if (response.success) {
    originalFaults.length = 0;
    isEditing.value = false;
    clearDiscounts();
    await fetchInfractionById(infraction.value.id);
  } else {
    // console.log("status ", response.status);
    // console.log("Hubo un error al actualizar la infracción.");
  }
  loading.value = false;
  clearMessageForModal();
};

const clearDiscounts = () => {
  infraction.value.discount_numeric = null;
  infraction.value.discount_percentage = null;
};

const submitStateUpdate = async (description, files, physicalNoti) => {
  loading.value = true;
  getMessageForModal(selectedState.value.state_name ?? "");
  //await new Promise(resolve => setTimeout(resolve, (8 * 60 * 1000)));
  const filesCode = crypto.randomUUID();

  if (description && !description.endsWith(".")) {
    description += "."; // Agrega un punto al final si no lo tiene.
  }
  if (message.value && !message.value.endsWith(".")) {
    message.value += "."; // Agrega un punto al final si no lo tiene.
  }

  const body = {
    infractionId: infraction.value.id,
    stateId: selectedState.value.id,
    comment: description ?? "",
    subtittle: subtittle.value,
    message: description ?? message.value,
    cidi: store.state.CidiCookie,
    filesCode: filesCode,
  };

  //agregar el campo de si es necesario una notificacion y el de que se intenta
  body.needNotification = physicalNoti.isNeeded;
  body.tryCidi = physicalNoti.tryCidi;
  if (physicalNoti?.optionId) body.optionId = physicalNoti.optionId;

  if (functionTo) {
    store.dispatch("clearBodyInfractionState");
    const state = { body, cost: infraction.value.cost };
    store.dispatch("saveBodyInfractionState", state);
    let infra = infraction.value;
    if (files.length > 0) {
      infra = {
        ...infraction.value,
        files: files,
        filesCodeAux: filesCode,
        comment: body.comment,
        filesToUp: files,
      };
    } else {
      infra = {
        ...infraction.value,
        filesCodeAux: filesCode,
        comment: body.comment,
      };
    }
    infra.bodyTransition = body;
    const response = await functionTo(infra);
    if (!response.success) {
      if (!response.notCut) {
        loading.value = false;
        isEditing.value = false;
        succesTransition.value = false;
        toast.error("No es posible actualizar en este momento");
      }
      return;
    }

    body.message += response.data;
    body.comment += response.data;

    //aca cortara el proceso aquellas acciones que tengan functionTo que finalicen por si mismas el cambio de estado exitosamente
    if (response.finished) {
      originalFaults.length = 0;
      isEditing.value = false;
      loading.value = false;
      succesTransition.value = true;
      clearMessageForModal();
      return;
    }
    store.dispatch("clearBodyInfractionState");
  }

  const response = await StateTransitionService.changeStateInfraction(body);

  if (response.success) {
    originalFaults.length = 0;
    isEditing.value = false;
    succesTransition.value = true;
    transition.value.id = response.data;
    transition.value.uuid = filesCode;
  } else {
    //console.log("status ", response.message);
    // console.log("Hubo un error al actualizar la infracción.");
    await fetchInfractionById(infraction.value.id);
    isEditing.value = false;
    succesTransition.value = false;
    toast.error("No es posible actualizar en este momento");
  }
  loading.value = false;
  clearMessageForModal();
  return response;
};

const submitObservation = async (description) => {
  loading.value = true;
  getMessageForModal("SavingObservation");
  //await new Promise(resolve => setTimeout(resolve, (8 * 60 * 1000)));
  const filesCode = crypto.randomUUID();

  if (description && !description.endsWith(".")) {
    description += "."; // Agrega un punto al final si no lo tiene.
  }

  const body = {
    id: infraction.value.id,
    comment: description ?? "",
    //por el momento no habra persona que cometa el hecho
    filesCode: filesCode,
  };

  const response = await InfractionService.createObservation(body);

  if (response.success) {
    originalFaults.length = 0;
    isEditing.value = false;
    succesObservation.value = true;
    transition.value.id = response.data;
    transition.value.uuid = filesCode;
  } else {
    //console.log("status ", response.message);
    // console.log("Hubo un error al actualizar la infracción.");
    await fetchInfractionById(infraction.value.id);
    isEditing.value = false;
    succesObservation.value = false;
    toast.error("No es posible actualizar en este momento");
  }
  loading.value = false;
  clearMessageForModal();
  return response;
};

const closeTransition = () => {
  modalTransitionV.value = false;
  modalObservation.value = false; //modal de observaciones
  modalHistorial.visible = false;
};

const closeTransitionAndFetch = async () => {
  loading.value = true;
  //getMessageForModal("FetchingById")
  succesTransition.value = false;
  await fetchInfractionById(infraction.value.id);
  modalTransitionV.value = false;
  modalObservation.value = false; //modal de observaciones
  loading.value = false;
  clearMessageForModal();
};

const popFile = (index) => {
  files.splice(index, 1);
};

const handleFileUpload = (event) => {
  const file = event.target.files[0];
  if (file) {
    selectedFile.value = file;
    files.push(file);
  }
};

const postFile = async (code) => {
  try {
    const response = await GeneralFunctions.saveFilesOnInfractionsAPI(
      files,
      code,
    );
    if (response.success) files.splice(0, files.length);
    return response;
  } catch (error) {
    // console.log("error post file ", error)
    return { success: false };
  }
};

/*const saveManualCommunication = async (state) => {
  if (files.length < 1) return
  loading.value = true;
  getMessageForModal("UpdatingNotification")
  if (!state.filesCode) {
    state.filesCode = crypto.randomUUID();
  }
  const response = await postFile(state.filesCode)
  if (response.success) {
    const res = await StateTransitionService.updateNotification(state.id, state.filesCode)
    loading.value = false;
    if (res.success) {
      await fetchInfractionById(infraction.value.id);
      toast.success('Notificacion manual guardada con exito')
    } else {
      toast.error('Fallo en actualizarse la notificación');
    }
  } else {
    loading.value = false;
    toast.error('Error al guardar el archivo');
  }

  loading.value = false;
  clearMessageForModal();
}*/

const clearMessageForModal = () => {
  loadingModalMessage.value = "";
};

const getMessageForModal = (situation) => {
  const situ = LoadingMessages.Messages.find(
    (item) => item.situation === (situation ?? ""),
  );
  loadingModalMessage.value = situ?.message ?? "";
};

const passValidation = () => {
  return (
    ValidOriginalTitular &&
    ValidOriginalVehicle &&
    originalInfra.internal_number
  );
};

const ModalTransiton = async (newState) => {
  if (actionMap[newState.state_name]) {
    const content = await actionMap[newState.state_name](
      deepClone(infraction.value),
    );

    if (content.needValidation) {
      if (!passValidation()) {
        errorTransitionMessage.value =
          "necesitas completar y guardar todos los datos faltantes para efectuar este cambio";
        errorTransition.value = true;
        return;
      }
      errorTransition.value = false;
    }

    subtittle.value = content.subtittle;
    message.value = content.message;

    //le ponemos el mensaje default para que lo tenga de placeholder y lo pueda modificar
    if (!isUser.value) transition.value.message = content.message;

    if (content.function) transition.value.document = content.function;
    if (content.procedure) {
      transition.value.procedure = true;
      functionTo = content.procedure.function;
      if (!content.procedure.allowComment) {
        selectedState.value = newState;
        await submitStateUpdate("", []);
        return;
      }
    }
  } else {
    // console.warn(`No hay acción definida para el estado: ${newState.state_name}`);
  }
  infraction.value.selectedState = newState;
  selectedState.value = newState;
  modalTransitionV.value = true;
};

const ModalObservation = () => {
  modalObservation.value = true;
};

const getStateAction = (stateName) => {
  // Busca el estado en StateService.stateAction
  const state = StateService.stateAction.find(
    (item) => item.name === stateName,
  );
  return state ? state.action : null; // Retorna el color si lo encuentra o un color por defecto
};

const formatDate = (dateString) => {
  const options = { day: "numeric", month: "numeric", year: "numeric" };
  return new Date(dateString).toLocaleDateString("es-ES", options);
};

const getStateColor = (stateName) => {
  // Busca el estado en StateService.stateAction
  const state = StateService.stateAction.find(
    (item) => item.name === stateName,
  );
  return state ? state.color : "#000"; // Retorna el color si lo encuentra o un color por defecto
};

const saveInternalNumber = async () => {
  loading.value = true;
  const numeroEntero = parseInt(infraction.value.internal_number, 10); // Base 10 para decimales

  if (isNaN(numeroEntero)) {
    loading.value = false;
    // console.log("El número de entero debe ser un número válido.");
    return;
  }
  const response = await InfractionService.AssignInternal(
    infraction.value.id,
    numeroEntero,
  );
  if (response.success) {
    if (originalInfra.internal_number !== infraction.value.internal_number) {
      await fetchInfractionById(infraction.value.id);
    }
  }
  loading.value = false;
};

onUpdated(() => {
  if (!propsLoaded.value) {
    infraction.value = props.obj.infraction;
    possiblesStates.value = props.obj.states;
    propsLoaded.value = true;
  }
  if (!isEditing.value) {
    //si esta editando no actualizamos la lista original de faltas
    originalFaults.push(...infraction.value.faults);
  }
  if (originalInfra !== props.obj.infraction && props.isEvent) {
    props.eventReceived();
    titularUndefined.value = props.obj.infraction.act.infractor_cuil
      ? false
      : true;
    infraction.value = props.obj.infraction;
    saveOriginalInfra();
  }
});

const titularUndefined = ref(false);
onMounted(async () => {
  if (store.state.user.role) fetchFaults();
  if (!props.obj.infraction.act.infractor_cuil) titularUndefined.value = true;
  await saveOriginalInfra();
});
</script>

<style scoped>
.extraordinaryDiscounts {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.inputDiscount {
  width: 69px;
  max-width: 169px;
}

/*para table faltas */
.custom-table {
  width: 100%;
  border-collapse: separate;
  /* Cambia a 'separate' para permitir el espaciado entre celdas */
  border-spacing: 5 10px;
  /* Agrega espaciado vertical entre las filas */
}

.custom-table th,
.custom-table td {
  padding: 8px;
  text-align: center;
}

.custom-table th {
  background-color: rgba(0, 195, 168, 0.2);
  border-radius: 5px;
  /*text-align: left; habilitar si se quieren titulos a la izq*/
}

.custom-table td {
  background-color: transparent;
  /* Elimina el fondo de las celdas del cuerpo */
}

.remove-button {
  background: #f44336;
  color: var(--bg-popup);
}

/* hasta aca estilos table */
.submitTDiv {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.error-text {
  color: red;
  font-size: 0.9em;
}

.invalid {
  border: 1px solid red;
}

.fondoLoader {
  min-height: 100vh;
  width: 100vw;
  background: rgba(83, 83, 83, 0.527);
  backdrop-filter: blur(22.5px);
  position: absolute;
  top: 0;
  z-index: 5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.loader {
  width: 48px;
  height: 48px;
  border: 5px solid var(--verdePrincipal);
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

.loading {
  width: 25%;
  margin: auto;
  gap: 5px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

#loaderSignal {
  animation: normal !important;
}

.pointer-cursor {
  cursor: pointer;
}

.switch {
  position: relative;
  display: inline-block;
  width: 34px;
  height: 20px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  /*cursor: pointer;*/
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 20px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 3px;
  bottom: 3px;
  background-color: var(--bg-popup);
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #4caf50;
}

input:checked + .slider:before {
  transform: translateX(14px);
}

a {
  text-decoration: none;
}

.containerGeneral {
  padding-top: 32px;
  padding-left: 18px;
  width: 100%;
}

.containerTramites {
  width: 100%;
  margin: 18px;
  margin-top: 12px;
  white-space: nowrap;
  /* cursor: grab; */
  overflow-x: auto;
  overflow-y: hidden;
  /*scrollbar-color: #fff6 #00000026;*/
  scrollbar-width: auto;
}

.containerTramites:active {
  cursor: grabbing;
  /* Cambia el cursor durante el arrastre */
}

.containerTramites.scroll-active {
  overflow-x: scroll;
  /* Activa desplazamiento horizontal */
  touch-action: pan-x;
  /* Permite desplazamiento táctil */
  -webkit-overflow-scrolling: touch;
  /* Suaviza el scroll en iOS */
  scroll-behavior: smooth;
  /* Desplazamiento suave */
}

.containerTramites::-webkit-scrollbar {
  display: none;
  /* Oculta la barra de scroll en navegadores Webkit */
}

/* .fondoTramites {
  background-color: #f5f5f5;
} */
.container-medio {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: max-content;
  gap: 4px;
  display: flex;
  flex-wrap: nowrap;
  /* Previene el ajuste a la siguiente línea */
}

.containerTareas {
  width: 45%;
}

.pagNum {
  margin: 0 1.5px;
}

.imagenUrl {
  width: 400px;
}

.procedure-data-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-wrap: wrap;
}

.procedure-data {
  display: flex;
  flex-flow: column wrap;
  align-items: flex-start;
  align-self: stretch;
}

.user-data-container {
  display: flex;
  width: 620px;
  gap: 139px;
}

.infoText {
  text-align: start;
}

.user-data {
  display: flex;
  flex-flow: column wrap;
  align-items: flex-start;
  margin-top: 16px;
}

.description {
  display: flex;
  flex-wrap: wrap;
  margin-top: 8px;
}

.select {
  display: flex;
  width: 243.793px;
  border-radius: 26.766px;
  flex-direction: column;
  gap: 10px;
  margin: 8px;
}

.form-select {
  display: flex !important;
  --bs-form-select-bg-img: none;
  font-size: 13px;
  border-radius: 26.766px;
  height: 39.192px;
  color: var(--text-muted);
}

.response {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.filtro-top {
  width: 100%;
  color: var(--text-color);
  display: flex;
  justify-content: space-around;
  background: var(grey);
  height: 3rem;
}

.finalized {
  color: var(--text-primary);
  text-align: center;
  font-family: Montserrat;
  font-style: normal;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  /* 171.429% */
}

.modal-content-constancia {
  display: block;
  height: 100%;
  width: 100%;
  padding: 1rem;
  background-image: url("@/assets/images/pie-de-mail 2.png");
}

.modalOverlay-constancia {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.modal-constancia-top {
  display: flex;
  width: 502.271px;
  height: 33.18px;
  flex-shrink: 0;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: -20%;
}

.modalConstancia {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 541px;
  height: 412px;
  padding: 43.477px 36.612px 36.612px 36.612px;
  background: var(--bg-popup);
  border-radius: 18.306px;
}

.contents {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.constancia-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
}

.constancia-content2 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
}

.imageConstancia {
  margin-top: 13%;
}

.linea-constancia {
  width: 541.425px;
  height: 10.313px;
  flex-shrink: 0;
  background: linear-gradient(
    270deg,
    #00c3a8 0.31%,
    #ffb900 45.75%,
    #ff2745 98.45%
  );
}

.modal-content-InicioModal {
  display: block;
  height: 100%;
  width: 100%;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
  padding: 1rem;
}

.modal-content-finalizarTramite {
  display: block;
  height: 100%;
  width: 100%;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
  padding: 1rem;
}

.modal-content-requerimiento {
  min-height: 405px;
  width: 100%;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.modal-content-task {
  height: 493px;
  padding: 32px;
  width: 100%;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
}

.modalRespuesta {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10;
  position: absolute;
  top: 10rem;
  right: 30rem;
  margin-left: auto;
  margin-right: auto;
  height: auto;
  width: 550px;
  /* Need a specific value to work */
  text-align: center;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 10px;
  word-break: break-all;
}

.modalTarea {
  display: flex;
  align-items: center;
  position: absolute;
  width: 529px;
  left: 32%;
  top: 12%;
  border-radius: 16px;
  background: var(--bg-popup);
}

.modalRequerimiento {
  display: flex;
  align-items: center;
  position: absolute;
  width: 529px;
  left: 32%;
  top: 12%;
  border-radius: 16px;
  background: var(--bg-popup);
}

.data-container {
  display: flex;
  flex-flow: column wrap;
  height: auto;
  text-align: left;
}

.modalOverlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 550;
}

.graficoContainer {
  display: flex;
  flex-direction: column;
  z-index: 1;
  margin-top: 21%;
  position: fixed;
  transform: translate(-40%, -48%);
  width: 90%;
  max-width: 45rem;
  max-height: 81vh;
  padding: 42px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 8px 32px rgba(31, 38, 135, 0.37);
  backdrop-filter: blur(10px);
  border-radius: 10px;
  /*border: 1px solid rgba(255, 255, 255, 0.18);*/
  overflow-y: auto;

  left: 46%;
  position: absolute;
}

body {
  overflow: hidden;
  /* Evita que la página se desplace mientras el modal está abierto */
}

.cant {
  display: flex;
  margin: 0;
}

input[type="checkbox"] {
  appearance: none;
  border: 1px solid #666;
  border-radius: 0.125rem;
  box-shadow: inset 0 0 0 0.125rem var(--bg-popup);
  display: inline-block;
  height: 1rem;
  width: 1rem;
  vertical-align: bottom;
}

input[type="checkbox"]:checked {
  background: var(--color-success);
}

input[type="search"] {
  border-radius: 10px;
  margin-right: 2%;
}

.filtro-filas {
  color: var(--text-color);
  padding: 10px;
  display: flex;
  align-items: baseline;
  justify-content: space-between;

  width: 100%;
  height: 40px;
}

.tabla-title {
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: 15px;
  background: var(--Gris-claro, #f5f5f5);
}

.titleCards {
  display: flex;
  height: 58px;
  flex-direction: column;
  justify-content: center;
  color: var(--text-primary);
  font-family: Montserrat;
  text-align: center;
  font-size: 17.5px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  text-transform: uppercase;
  text-decoration: none;
}

.titulomodal {
  color: #4b4a49;
  font-family: Montserrat;
  font-size: 16.789px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: -0.839px;
  margin-bottom: 4px;
  text-decoration-line: underline;
}

.linea-datosBasicos {
  width: 448px;
  margin-left: 10px;
  margin-top: 14px;
  height: 1.199px;
  flex-shrink: 0;
  border-radius: 1.589px;
  background: #4b4a49;
}

.linea-auto-oscurita {
  width: 100%;
  /* Se adapta al ancho del contenedor */
  max-width: 448px;
  /* Tamaño máximo opcional */
  margin-left: 10px;
  margin-top: 14px;
  height: 1.199px;
  flex-shrink: 0;
  border-radius: 1.589px;
  background: #4b4a49;
}

.linea-infoTramite {
  width: 368px;
  margin-left: 10px;
  margin-top: 14px;
  height: 1.199px;
  flex-shrink: 0;
  border-radius: 1.589px;
  background: #4b4a49;
}

.linea-requerimiento {
  width: 400px;
  height: 1px;
  flex-shrink: 0;
  border-radius: 1.589px;
  background: #4b4a49;
}

.linea-auto {
  width: 100%;
  /* Se adapta al ancho del contenedor */
  max-width: 400px;
  /* Tamaño máximo opcional */
  margin-left: 10px;
  margin-top: 14px;
  height: 1px;
  /* Altura fija */
  flex-shrink: 0;
  border-radius: 1.589px;
  background: #4b4a49;
}

.linea-respuestaReq {
  width: 327px;
  height: 1px;
  flex-shrink: 0;
  border-radius: 1.589px;
  background: #4b4a49;
}

.titulomodal-tasks {
  font-family: Montserrat;
  width: 469px;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  text-decoration: none;
  margin-bottom: 12px;
}

.titulomodal-requerimiento {
  font-family: Montserrat;
  width: 469px;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  text-decoration: none;
  margin-bottom: 12px;
}

.filtro-filas input {
  width: 15%;
  height: 20px;
}

.tabla-container {
  width: 282px;
  min-height: 200px;
  /* background-color: #f5f5f5; */
}

table {
  width: 100%;
}

th,
td {
  padding: 5px;
  border-bottom: 1px solid var(--grey);
  background: var(--bg-popup);
  height: 40px;
  color: var(--blue);
  font-size: 0.9em;
  white-space: normal;
}

.fila-tabla:hover {
  outline: 1px solid var(--blue);
  cursor: pointer;
  user-select: none;
}

.estado-fila p {
  background: var(--grey-bk);
  border-radius: 20px;
  padding: 3px;
}

.filtro-img {
  max-width: 30px;
  margin-left: 1rem;
}

.filtro-container {
  width: 50%;
  color: var(--text-color);
  padding: 10px;
  display: flex;
  justify-content: space-around;
}

.filtro-container input {
  margin: 0 20px;
  background: inherit;
  color: var(--text-color);
  border: none;
  border-bottom: 1px solid var(--red);
}

.filtro-container input:hover {
  border-bottom: 2px solid var(--color-success);
  animation-name: border-animation;
  animation-duration: 2s;
}

.lineatarjetas {
  display: flex;
  align-self: stretch;
}

.lineaNuevos {
  display: flex;
  height: 58px;
  width: 295px;
  justify-content: center;
}

.lineaEnproceso {
  display: flex;
  height: 58px;
  width: 295px;
  justify-content: center;
}

.lineaRequeridos {
  display: flex;
  height: 58px;
  width: 295px;
  justify-content: center;
}

.lineaFueradeplazo {
  display: flex;
  height: 58px;
  width: 295px;
  justify-content: center;
}

.select {
  /*text-align: center;*/
  background: none;
  border-radius: 20px;
  border: 5px solid var(--red);
  outline: none;
  padding: 2px;
}

/* Opciones estilizadas */
.option {
  background: var(--color-success);
  color: var(--bg-popup);
  padding: 5px;
  cursor: pointer;
}

.option:hover {
  background: var(--bg-popup);
  /* Fondo blanco */
  color: var(--color-success);
  /* Texto verde */
}

.length {
  border: 1px solid gray;
  padding: 0px 5px;
}

.botonMuni {
  display: flex;
  font-size: 12.045px;
  line-height: 17.207px;
  /* 142.857% */
  color: var(--bg-popup);
  border-radius: 3.609px;
  background: var(--color-success);
  width: 250px;
  height: 23px;
  /*justify-content: center;*/
  /*align-items: center;*/
  /*flex-direction: column;*/
  gap: 5px;
  border: none;
  cursor: pointer;
}

.botonStatusMuni {
  border-radius: 3.609px;
  background: var(--color-success);
  /*width: 100.339px;*/
  height: 23.1px;
  flex-shrink: 0;
  border: none;
}

.butonTilde {
  border-radius: 50%;
  background: var(--color-success);
  width: 25px;
  height: 25px;
  flex-shrink: 0;
  border: none;
}

.disabled {
  background: #4b4a49;
  cursor: default;
}

.botonMuni p {
  color: var(--bg-popup);
  font-family: Montserrat;
  font-size: 12.045px;
  font-style: normal;
  font-weight: 600;
  line-height: 17.207px;
  /* 142.857% */
}

.botonStatusMuni p {
  color: var(--bg-popup);
  text-align: center;
  font-family: Montserrat;
  font-size: 12.045px;
  font-style: normal;
  font-weight: 600;
  margin-top: 2px;
  line-height: 17.207px;
  /* 142.857% */
}

.svg {
  width: 31.678px;
  height: 87.114px;
  position: absolute;
  left: 641px;
  top: 21px;
  cursor: pointer;
  filter: drop-shadow(0px 4px 10px rgba(97, 97, 97, 0.1));
}

.svg-tarea {
  position: absolute;
  left: 488px;
  top: 16px;
  /*width: 24px;*/
  height: 66px;
  cursor: pointer;
  filter: drop-shadow(0px 4px 10px rgba(97, 97, 97, 0.1));
}

.modal-top-requerimiento {
  text-align: center;
  padding-top: 32px;
}

.modal-top {
  /*display: flex;*/
  width: 100%;
  /*gap: 21.15px;*/
  margin-bottom: 31px;
  justify-content: space-between;
}

.innerModalTop {
  display: flex;
  justify-content: space-between;
}

.imagenYtitulo {
  display: flex;
  gap: 4.33px;
  flex-wrap: wrap;
  /* Permite el salto de línea */
  max-width: 300px;
  /* Limita el ancho para provocar saltos */
}

.titulos {
  color: var(--text-primary);
  font-family: Montserrat;
  font-size: 13.383px;
  font-style: normal;
  font-weight: 600;
  line-height: 19.119px;
  /* 142.857% */
  margin-top: 6px;
  white-space: normal;
  /* Asegura que el texto pueda envolver líneas */
}

.modal-top-tarea {
  text-align: center;
  /* padding-top: 32px; */
  width: 100%;
}

/*.modal-dialog {
  margin-top: 5%;
  position: fixed;
  left: 25%;
  transform: translate(-40%, -50%);
}*/

.user-text {
  color: var(--text-primary);
  text-align: center;
  font-family: Montserrat;
  font-size: 15.566px;
  font-style: normal;
  font-weight: 600;
  /* line-height: 16px;*/
}

.user-textAnswer {
  color: var(--text-primary);
  text-align: center;
  font-family: Montserrat;
  font-size: 15.566px;
  font-style: normal;
  font-weight: 400;
  line-height: 17.976px;
  /* 115.483% */
}

.user-info {
  color: var(--text-primary);
  text-align: center;
  font-family: Montserrat;
  font-size: 15.566px;
  font-style: normal;
  font-weight: 400;
  /*line-height: 17.976px; */
}

.sinTramites {
  position: relative;
  width: 100%;
  height: 150px;
  text-align: center;
  padding-top: 2rem;
}

.question {
  word-break: break-all;
}

.titleComunicacion {
  margin-bottom: 2rem;
  width: 100%;
}

.titleComunicacion input {
  width: 60%;
  border-radius: 10px;
  padding-left: 1rem;
}

textarea {
  border-radius: 10px 10px 0px 0px;
  padding-left: 1rem;
  margin-bottom: 2rem;
}

.botonSubmit {
  width: 100px;
  height: 45px;
  background-color: var(--color-success);
  border-radius: 20px 20px 0px 0px;
  color: var(--bg-popup);
  border-style: none;
  margin: auto;
  margin-bottom: 2rem;
}

.boton-tarea {
  display: flex;
  padding: 4px 16px;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  border-radius: 8px;
  background: var(--color-yellow-muni);
  color: var(--bg-popup);
  font-family: Montserrat;
  font-size: 11.2px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  border: none;
}

.boton-action {
  display: flex;
  padding: 4px 16px;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  border-radius: 8px;
  color: var(--bg-popup);
  font-family: Montserrat;
  font-size: 11.2px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  border: none;
  max-width: 244px;
}

.boton-requerimiento {
  display: flex;
  padding: 4px 16px;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  border-radius: 8px;
  background: var(--color-error);
  color: var(--bg-popup);
  font-family: Montserrat;
  font-size: 11.2px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  border: none;
}

.boton-finalizar {
  display: flex;
  padding: 4px 16px;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  border-radius: 8px;
  background: var(
    --degrade-VA,
    linear-gradient(90deg, #00a3a8 4.26%, var(--color-yellow-muni) 126.04%)
  );
  color: var(--bg-popup);
  font-family: Montserrat;
  font-size: 11.2px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  border: none;
}

.contentCirculo {
  display: flex;
  flex-direction: column;
  width: 15px;
  margin: auto;
}

.circulo {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: black;
  margin-top: 2px;
}

.enviado {
  color: green;
  font-size: 25px;
  margin-left: 2rem;
}

.respuestas {
  border-radius: 10px;
  border: 1px solid #666;
  width: 100%;
  margin-top: 1rem;
  text-align: left;
  padding: 5px;
}

.respuestas a {
  text-decoration: none;
}

/* .finalizar {
      width: 30%;
      margin: auto;
      margin-top: 1rem;
    } */
.title {
  position: absolute;
  top: 1rem;
  background-color: #666;
  height: 100px;
}

.requerimiento {
  margin-bottom: 1rem;
  position: relative;
  max-width: 33rem;
  word-break: break-all;
}

.historialReq {
  display: flex;
  gap: 3px;
  color: var(--text-primary);
  text-align: center;
  font-family: Montserrat;
  font-size: 11.2px;
  font-style: normal;
  font-weight: 400;
}

.footer {
  margin-top: 5%;
  display: flex;
  align-items: flex-start;
  justify-content: space-evenly;
  gap: 16px;
  align-self: stretch;
}

.lineaHistorica {
  height: 150px;
  margin-left: 10px;
}

.circulos {
  position: absolute;
  width: 17.54px;
  height: 17.54px;
  border-radius: 50%;
  border: 2px solid var(--color-success);
  background-color: var(--bg-popup);
  top: -7px;
  cursor: pointer;
}

.circulos.active {
  background-color: var(--color-yellow-muni);
}

.lineaTrazabilidad {
  position: relative;
  display: flex;
  margin-left: 30px;
  width: 520px;
  height: 4px;
  background-color: var(--color-success);
}

.ArribaLinea {
  display: flex;
  width: 1px;
  gap: 265px;
  border-radius: 1.589px;
  margin-left: 5px;
}

.AbajoLinea {
  display: flex;
  width: 320px;
  margin-top: 5px;
  margin-left: 155px;
  gap: 260px;
}

.bloque {
  display: flex;
  flex-direction: column;
}

.textTitleConstancia {
  color: var(--text-primary);
  text-align: center;
  font-family: Montserrat;
  font-size: 12px;
  font-weight: 600;
  line-height: 24px;
  /* 200% */
}

.textTitle {
  color: var(--text-primary);
  text-align: center;
  font-family: Montserrat;
  font-size: 12px;
  font-weight: 600;
  line-height: 24px;
  /* 200% */
}

.textFecha {
  color: var(--text-muted);
  text-align: center;
  font-family: Montserrat;
  font-size: 10px;
  font-weight: 400;
  line-height: 24px;
  /* 240% */
}

.cardFiltros {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 2rem;
  padding-top: 2rem;
  border: 1px solid grey;
}

/* Evitar animaciones en actualizaciones */
/** {
  transition: none !important;
  animation: none !important;
}*/

/*.modal {
  display: none;
  /* Oculta el modal por defecto */
/*position: fixed;
  /* Fija el modal a la pantalla */
/*z-index: 1;
  /* Asegura que el modal esté por encima de otros elementos */
/*left: 0;
  top: 0;
  width: 100%;
  /* Cubre toda la pantalla */
/*height: 100%;
  /* Cubre toda la pantalla */
/*overflow: auto;
  /* Permite desplazamiento si el contenido es más largo que la pantalla */
/*background-color: rgba(0, 0, 0, 0.4);
  /* Fondo oscuro semitransparente */
/*
}*/

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  /* Centra el modal verticalmente */
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
  /* Ancho del modal */
  max-width: 600px;
  /* Ancho máximo del modal */
  box-sizing: border-box;
  /* Incluye el padding y el border en el ancho */
}

@media (max-width: 1200px) {
  .containerTramites {
    width: 95%;
    margin: auto;
    margin-top: 12px;
  }

  .tabla-container {
    width: 25%;
    min-height: 200px;
  }
}

@media (max-width: 768px) {
  .secondColumn {
    margin-right: 10%;
  }

  .modalTarea {
    margin: 8% auto;
    /* Ajusta el margen vertical en móviles */
    width: 90%;
    /* Ancho del modal en móviles */
    left: 0%;
    position: relative;
    top: 0%;
  }

  .modal-content {
    margin: 10% auto;
    /* Ajusta el margen vertical en móviles */
    width: 90%;
    /* Ancho del modal en móviles */
  }

  .graficoContainer {
    margin-top: 105%;
    left: 40%;
    width: 89%;
    padding: 5px;
  }

  .modal-content-InicioModal {
    width: 100%;
  }

  .innerModalTop {
    margin-right: 5%;
  }

  .sectionInfo {
    width: 100%;
  }

  .svg {
    left: 90%;
    top: 5%;
    height: 50px;
  }

  .user-data-container {
    display: flex;
    width: 100%;
    gap: 0px;
    justify-content: space-between;
  }

  .linea-auto-oscurita,
  .linea-auto {
    width: 0%;
    visibility: collapse;
  }

  .titulomodal-tasks {
    width: 100%;
  }

  .svg-tarea {
    position: absolute;
    left: 89%;
    top: 3%;
    /*width: 24px;*/
    height: 66px;
  }
}

.plazoTask {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-end;
}

.container-input {
  text-align: center;
  align-items: center;
  background: var(--color-yellow-muni);
  padding: 4px 16px;
  border-radius: 4px;
  border: none;
  color: #f5f5f5;
  height: 24px;
  width: fit-content;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.hidden-input {
  opacity: 0;
  overflow: hidden;
  position: absolute;
  width: 100%;
  /* Ajusta según tu diseño */
  cursor: pointer;
}

.button-round {
  color: var(--bg-popup);
  text-align: center;
  align-items: center;
  background: var(--color-yellow-muni);
  padding: 4px 16px;
  border-radius: 20%;
  border: none;
  width: 15px;
  height: 24px;
  display: flex;
  flex-direction: row;
  margin-left: 3px;
  justify-content: center;
}

/*estilos para timeline */

.timeline-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
}

.timeline-item {
  display: flex;
  align-items: flex-start;
  position: relative;
  min-height: 60px;
  /* Asegura que haya suficiente espacio entre elementos */
  width: 100%;
}

.timeline-line {
  position: absolute;
  width: 3px;
  background-color: var(--color-success);
  left: 7px;
  /* Ajuste fino para centrar la línea con los puntos */
  /*left: 2.5%;*/
  top: 18px;
  bottom: -15px;
  /* Conexión perfecta entre puntos */
}

.timeline-point {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: var(--color-success);
  cursor: pointer;
  transition: transform 0.2s;
  position: absolute;
  left: 0px;
  top: 15px;
  /* Alineado al centro */
}

.timeline-point:hover {
  transform: scale(1.2);
}

.timeline-card {
  background: var(--bg-popup);
  border-radius: 12px;
  padding: 10px 15px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-in-out;
  width: 90%;
  cursor: pointer;
  overflow: hidden;
  margin-left: 8%;
  /* Espacio para la línea y puntos */
  margin-bottom: 5px;
  /* Espacio entre tarjetas */
}

.timeline-card.expanded {
  width: 90%;
  max-width: 90%;
  background: #f9f9f9;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.timeline-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.timeline-title {
  font-weight: bold;
  color: #333;
}

.timeline-date {
  font-size: 0.9em;
  color: #666;
}

.timeline-content {
  margin-top: 10px;
}

.file-link {
  display: block;
  color: #007bff;
  text-decoration: underline;
  margin-top: 5px;
  width: fit-content;
}
</style>
